import {lookup} from 'country-data-list';
import languageNameMap from 'language-name-map/map';

const pushAdobeEvent = (event) => {
    // const { pageName } = getAdobeAnalyticsPageDetails();
    // // Add pageName to cta data
    // if ('cta' in event && event.cta) {
    //   event.cta.pageName = pageName;
    // }
    // // Add new building data to all clicks and pageViews except for the homepage
    // if (
    //   !event.newBuilding &&
    //   ((event.event === ANALYTICS_EVENTS.CLICK && pageName !== 'studio:home') ||
    //     (event.event === ANALYTICS_EVENTS.PAGE_VIEW && pageName !== 'studio:home'))
    // ) {
    //   event.newBuilding = getNewBuilding();
    // }
    // // Add product name to newBuilding data for product detail pages
    // if (event.newBuilding && event.event === ANALYTICS_EVENTS.PAGE_VIEW && pageName.startsWith('studio:product detail:')) {
    //   event.newBuilding.productName = event.page.pageName.replace('studio:product detail:', '');
    // }

    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.adobeDataLayer.push(event);
    } catch (error) {
      console.warn('Failed to push Adobe event', event); // eslint-disable-line no-console
    }
  };


const getLangCodeFromName = (languageName) => {
  const normalized = String(languageName || '').trim().toLowerCase();
  return Object.keys(languageNameMap).find(
    (code) => languageNameMap[code].name.toLowerCase() === normalized
  ) || '';
};

export const getLanguageCode = (country, languageName) => {
  const langCode = getLangCodeFromName(languageName);
  const countryMatches = lookup.countries({name: country});
  const region = countryMatches.length ? countryMatches[0].alpha2.toUpperCase() : '';

  if (langCode && region) {
    return `${langCode}-${region}`;
  }
  return langCode;
};

/**
 * Page load event
 *
 * adobeDataLayer.push({
            "event": "page-load",
            "page": {
                "pageName": "paroc | calculus | paroc-calculus | index_gb.html#",
                "path": "/paroc-calculus/index_gb.html#/",
                "referringURL": "https://www.paroc.com/en-gb/tools-documents/calculators/calculus",
                "previousPath": "/en-gb/tools-documents/calculators/calculus",
                "previousPathNoLocale": "/tools-documents/calculators/calculus"
            },
            "site": {
                "locale": {
                    "country": "United Kingdom",
                    "languageName": "English",
                    "code": "en-gb"
                },
                "domain": "calculus.paroc.com",
                "name": "paroc calculus",
                "section1": "paroc:calculus:paroc-calculus",
                "section2": "paroc:calculus:paroc-calculus:index_gb.html",
                "section3": "", // leave empty if not applicable
                "section4": "", // leave empty if not applicable
                "section5": "", // leave empty if not applicable
                "section6": "", // leave empty if not applicable
                "section7": "", // leave empty if not applicable
                "section8": ""  // leave empty if not applicable
            },
            "visitor": {
                "createdDate": "2018-06-18T20:02:00.911+00:00",
                "lastUpdatedDate": "2024-06-18T20:02:00.911+00:00",
                "daysSinceLastLogin": 15, // if known, else blank
                "signInCount": "3", // if known, else blank
                "status": "logged-in", // logged-in, not-logged-in
                "visitorID": "01234567", // some visitor ID value that is not PII
                "selectedZip": "",
                "geoLocation": {
                    // if known
                    "city": "",
                    "region": "", // region or state
                    "country": "",
                    "zip": ""
                }
            }
        });

 */
export const adobePageLoad = (window, document, user) => {

    const windowHref = window.location;

    const path = windowHref.pathname === '/paroc-calculus/' || windowHref.pathname === '/calculus-testing/' || windowHref.pathname === '/' ? 'index.html' : windowHref.pathname.replace(/(\/paroc-calculus\/)|(\/calculus-testing\/)/g, '');
    const environment = windowHref.pathname === '/paroc-calculus/' ? 'paroc-calculus' : 'calculus-testing';
    const referringURL = document.referrer;
    const previousPath = referringURL.replace(/https?:\/\/[^\/]+/, '');
    let localInfo = null;
    if (user && user.uid) {
      localInfo = {
        country: user.field_country,
        languageName: user.field_user_interface_language,
        code: getLanguageCode(user.field_country, user.field_user_interface_language),
      };
    } else {
      localInfo = {
        country: 'Global',
        languageName: 'English',
        code: 'en',
      };
    }
    pushAdobeEvent({
    'event': 'page-load',
    'page': {
      'pageName': `paroc | calculus | ${environment} | ${path}`,
      'path': path,
      'referringURL': referringURL,
      'previousPath': previousPath
    },
    'site': {
      'locale': localInfo || {
        country: 'United Kingdom',
        languageName: 'English',
        code: 'en-gb',
      },
      'domain': 'calculus.paroc.com',
      'name': 'paroc calculus',
      'section1': `paroc:calculus:${environment}`,
      'section2': `paroc:calculus:${environment}:${path}`,
    },
    'visitor': {
      'visitorID': user && user.uid ? user.uid : null,
      'status': user && user.uid ? 'logged-in' : 'not-logged-in',
    }
  });
};

/**
 * Clicking insulation object on calculation page
 *
 * adobeDataLayer.push({
        "event": "cta", // event that triggered modal to open
        "eventInfo": {
            "action": "click", // action is open modal
            "detail": "circular tank", // click text
            "label": "circular tank", // english object name
            "type": "tab", // supported values = link, button, image, tab, accordion, close x, close background, checkbox, input, icon
            "text": "circular tank", // english click text of clicked element if possible
            "linkType": "display action link", // supported values = external link, internal link, display action link, download link, jump link
            "region": "select object", // section of page where element being engaged with exists
            "regionType": "page body"
        }
    });

 */

export const adobeClickInsulationObject = (labelLocal, labelEn, region) => {
    pushAdobeEvent({
        'event': 'cta',
        'eventInfo': {
          'action': 'click',
          'detail': labelLocal,
          'label': labelEn.toLowerCase(),
          'type': 'tab',
          'text': labelEn.toLowerCase(),
          'linkType': 'display action link',
          'region': region,
          'regionType': 'page body'
        }
    });
};    

export const adobeClickSaveProject = (projectNameOrId) => {
    pushAdobeEvent({
        'event': 'cta',
        'eventInfo': {
          'action': 'click',
          'detail': projectNameOrId,
          'label': 'save project',
          'type': 'button',
          'text': 'save project',
          'linkType': 'display action link',
          'region': 'project name',
          'regionType': 'page body'
        }
    });
};

export const adobeSelectInsulationProduct = (labelEn) => {
    pushAdobeEvent({
      'event': 'cta',
      'eventInfo': {
        'action': 'select',
        'detail': 'insulation product',
        'label': labelEn.toLowerCase(),
        'type': 'accordion',
        'text': labelEn.toLowerCase(),
        'linkType': 'display action link',
        'region': 'select item',
        'regionType': 'page body'
      }
    });
  };
  


/**
 * Clicking Save as PDF button on calculation page
 *
 * adobeDataLayer.push({
        "event": "cta", // event that triggered modal to open
        "eventInfo": {
            "action": "open modal", // action is open modal
            "detail": "save as pdf", // click text
            "label": "save as pdf modal", // modal name being opened
            "type": "button", // supported values = link, button, image, tab, accordion, close x, close background, checkbox, input, icon
            "text": "save as pdf", // english click text of clicked element if possible
            "linkType": "display action link", // supported values = external link, internal link, display action link, download link, jump link
            "region": "results", // section of page where element being engaged with exists
            "regionType": "page body"
        }
    });

 */
export const adobeClickOpenSaveAsPDFModal = () => {
  pushAdobeEvent({
    'event': 'cta',
    'eventInfo': {
      'action': 'open modal',
      'detail': 'save as pdf',
      'label': 'save as pdf modal',
      'type': 'button',
      'text': 'save as pdf',
      'linkType': 'display action link',
      'region': 'results',
      'regionType': 'page body'
    }
  });
};

/**
 * Save pdf event
 *
 * adobeDataLayer.push({
        "event": "cta", // event that triggered download
        "eventInfo": {
            "action": "download", // action is download
            "detail": "< insert unique file id >", // file id being saved/downloaded
            "label": "calculus results", // document type being downloaded
            "type": "button", // supported values = link, button, image, tab, accordion, close x, close background, checkbox, input, icon
            "text": "save", // english click text of clicked element if possible
            "location": "< insert file location >", // href or server file location of clicked element
            "linkType": "download link", // supported values = external link, internal link, display action link, download link, jump link
            "region": "save as pdf modal", // section of page where element being engaged with exists
            "regionType": "modal", // supported values = modal, page body, header, footer
            "downloads": {
                "fileDetails": [{
                    "fileID": "< insert unique file id >", // file id being saved/downloaded
                    "fileName": "< insert friendly file name >", // friendly file name being saved/downloaded
                    "fileType": "pdf", // file type being downloaded
                    "documentType": "calculus results" // document type being downloaded
                }]
            }
        }
    });

 */
export const adobeSavePDF = () => {
  pushAdobeEvent({
    'event': 'cta',
    'eventInfo': {
      'action': 'download',
      'detail': 'Paroc-Calculus.pdf',
      'label': 'calculus results',
      'type': 'button',
      'text': 'save',
      'linkType': 'download link',
      'region': 'save as pdf modal',
      'regionType': 'modal',
      'downloads': {
        'fileDetails': [{
          'fileName': 'Paroc-Calculus.pdf',
          'fileType': 'pdf',
          'documentType': 'calculus results'
        }]
      }
    }
  });
};

export const adobeCancelSavePDF = () => {
  pushAdobeEvent({
    'event': 'cta',
    'eventInfo': {
      'action': 'cancel',
      'label': 'calculus results',
      'type': 'button',
      'text': 'cancel',
      'linkType': 'display action link',
      'region': 'save as pdf modal',
      'regionType': 'modal',
    }
  });
};

export const adobeClickBecomeRegisterUser = (labelLocal, labelEn) => {
  pushAdobeEvent({
    'event': 'cta',
    'eventInfo': {
      'action': 'click',
      'label': labelLocal.toLowerCase(),
      'type': 'link',
      'text': labelEn.toLowerCase(),
      'linkType': 'external link',
      'region': 'header',
      'regionType': 'page body'
    }
  });
};

export const adobeLogIn = () => {
  pushAdobeEvent({
    'event': 'cta',
    'eventInfo': {
      'action': 'login',
      'label': 'login button',
      'type': 'button',
      'text': 'login',
      'linkType': 'display action link',
      'region': 'login button',
      'regionType': 'modal'
    }
  });
};
